const NotFound = () => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
    <div>存在しないページです</div>
  </div>
);

export default NotFound;
